import AlertIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/AlertIcon';
import AlertTriangleIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/AlertTriangleIcon';
import ArrowUpIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ArrowUpIcon';
import BackIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/BackIcon';
import ChevronDownIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ChevronDownIcon';
import ChevronRightIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ChevronRightIcon';
import ChevronUpIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ChevronUpIcon';
import CloneIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/CloneIcon';
import CloseIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/CloseIcon';
import ClustersLogoIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ClustersLogoIcon';
import DotIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/DotIcon';
import EditIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/EditIcon';
import ExternalLinkIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ExternalLinkIcon';
import FilterIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/FilterIcon';
import HideIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/HideIcon';
import InformationStatusIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/InformationStatusIcon';
import LockIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/LockIcon';
import MagGlassIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/MagGlassIcon';
import MenuIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/MenuIcon';
import NutanixLogoIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/NutanixLogoIcon';
import PlusIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/PlusIcon';
import QuestionIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/QuestionIcon';
import RemoveIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/RemoveIcon';
import SettingsIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/SettingsIcon';
import ShowIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/ShowIcon';
import StatusDotMiniIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/StatusDotMiniIcon';
import StatusTickMiniIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/StatusTickMiniIcon';
import SuccessStatusIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/SuccessStatusIcon';
import SyncIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/SyncIcon';
import TaskIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/TaskIcon';
import TickCircleIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/TickCircleIcon';
import TripleDotVerticalIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/TripleDotVerticalIcon';
import UnlockIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/UnlockIcon';
import WarningStatusIcon from '@nutanix-ui/prism-reactjs/lib/components/v2/Icons/WarningStatusIcon';

export {
  AlertIcon,
  AlertTriangleIcon,
  ArrowUpIcon,
  BackIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  CloneIcon,
  CloseIcon,
  ClustersLogoIcon,
  DotIcon,
  EditIcon,
  ExternalLinkIcon,
  FilterIcon,
  HideIcon,
  InformationStatusIcon,
  LockIcon,
  MagGlassIcon,
  MenuIcon,
  NutanixLogoIcon,
  PlusIcon,
  QuestionIcon,
  RemoveIcon,
  SettingsIcon,
  ShowIcon,
  StatusDotMiniIcon,
  StatusTickMiniIcon,
  SuccessStatusIcon,
  SyncIcon,
  TaskIcon,
  TickCircleIcon,
  TripleDotVerticalIcon,
  UnlockIcon,
  WarningStatusIcon,
};

export enum IconSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XL = 'extra-large',
  XXL = 'extra-xlarge',
}
